import * as types from "./actions.types";

interface ILogIn {
  type: types.LOG_IN;
}
export const logIn = (): ILogIn => ({ type: types.LOG_IN });

interface ILogOut {
  type: types.LOG_OUT;
}
export const logOut = (): ILogOut => ({ type: types.LOG_OUT });

export type Action = ILogIn | ILogOut;
